import { AchRecipientRecordModelDto } from '@treasury/api/channel';
import { format } from 'date-fns';
import { AchRecipient } from './ach-recipient.entity';

export class AchRecipientRecord extends AchRecipient<AchRecipientRecordModelDto> {
    public get recordId() {
        return this.dto.recordId;
    }

    public get recordType() {
        return this.dto.recordType === 'Batch' ? 'Template' : this.dto.recordType;
    }

    public get transactionIdTemplateName() {
        return this.dto.referenceNumber;
    }

    public get effectiveDate() {
        return this.dto.effectiveDate ? format(new Date(this.dto.effectiveDate), 'P') : '';
    }

    public get effectiveDateUnix() {
        return this.dto.effectiveDate ? new Date(this.dto.effectiveDate).getTime() : 0;
    }
}
